"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slot = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _SlotModule = _interopRequireDefault(require("./Slot.module.css"));
var _excluded = ["platform", "span", "id", "name", "catId", "catName", "onClick", "badge"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Slot = function Slot(_ref) {
  var platform = _ref.platform,
    span = _ref.span,
    id = _ref.id,
    name = _ref.name,
    catId = _ref.catId,
    catName = _ref.catName,
    onClick = _ref.onClick,
    badge = _ref.badge,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    style: {
      padding: '0.7rem',
      cursor: 'pointer',
      gridColumn: "span ".concat(span.x),
      gridRow: "span ".concat(span.y)
    },
    onClick: onClick
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      gridColumn: "span ".concat(span.x),
      gridRow: "span ".concat(span.y),
      /*aspectRatio: `calc(1.44 * ${span.x / span.y})`,*/
      '--aspect-ratio': "calc(0.7 * ".concat(span.x / span.y, ")")
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_SlotModule.default.container, _SlotModule.default[platform]),
    style: {
      backgroundImage: "url('https://sportcache.lider-bet.com/slotimages/all/".concat(id, ".png')")
    }
  }, badge && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(_SlotModule.default.badge, _SlotModule.default[badge.variant])
  }, badge.label.toUpperCase()), platform === 'web' && /*#__PURE__*/_react.default.createElement("div", {
    className: _SlotModule.default.overlay
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _SlotModule.default.title
  }, name), /*#__PURE__*/_react.default.createElement("div", {
    className: _SlotModule.default.buttonContainer
  }, /*#__PURE__*/_react.default.createElement("button", null, "PLAY NOW")), /*#__PURE__*/_react.default.createElement("span", {
    className: _SlotModule.default.category
  }, catName)))), platform === 'mob' && /*#__PURE__*/_react.default.createElement("span", {
    className: _SlotModule.default.title,
    style: {
      display: 'inline-block',
      marginTop: '0.5rem'
    }
  }, name));
};
exports.Slot = Slot;
Slot.propTypes = {
  platform: _propTypes.default.oneOf(['web', 'mob']),
  span: _propTypes.default.object,
  id: _propTypes.default.number,
  name: _propTypes.default.string,
  catId: _propTypes.default.number,
  catName: _propTypes.default.string,
  badge: _propTypes.default.object
};
Slot.defaultProps = {
  platform: 'web',
  span: {
    x: 1,
    y: 1
  },
  id: 5233,
  name: 'Blue Oceans',
  catId: 5,
  catName: 'EGT SLOT',
  badge: null
};